import { render, staticRenderFns } from "./BubbleTextMenu.vue?vue&type=template&id=57ac5eee&"
import script from "./BubbleTextMenu.vue?vue&type=script&lang=js&"
export * from "./BubbleTextMenu.vue?vue&type=script&lang=js&"
import style0 from "./BubbleTextMenu.vue?vue&type=style&index=0&id=57ac5eee&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports